import { createEntityAdapter } from '@reduxjs/toolkit';
import { INewsFeedPost } from './newsFeedInterfaces';

export const newsFeedEntityAdapters = {
  posts: createEntityAdapter<INewsFeedPost>({
    selectId: x => x.dpNewsFeedPostId,
    sortComparer: (a, b) => b.startDateUtc.localeCompare(a.startDateUtc)
  })
};
